import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const gorgiasRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Gorgias" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { Component: Page };
    },
    children: [
      {
        path: "connect",
        async lazy() {
          const { Connect } = await import("./connect");
          return { Component: Connect };
        },
      },
      {
        path: "callback",
        async lazy() {
          const { Callback } = await import("./callback");
          return { Component: Callback };
        },
      },
    ],
  },
];
